import React from 'react';
import { NewQuestion } from './QuestionForm';
export default function QuestionNew({ question }) {
  return <NewQuestion question={question} />;
}
